import { render, staticRenderFns } from "./StatisticsWdTurnoverCodesChart.vue?vue&type=template&id=10bba2c4&"
import script from "./StatisticsWdTurnoverCodesChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnoverCodesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports